import request from '@/config/axios'

export interface SiteVO {
  id?: number
  name: string
  code: string
  domain?: string
  logo?: string
  status: number
  sort: number
  remark?: string
  createTime?: Date
}

// 查询站点分页
export const getSitePage = (params: PageParam) => {
  return request.get({ url: '/scenic/site/page', params })
}

// 查询站点详情
export const getSite = (id: number) => {
  return request.get({ url: '/scenic/site/get?id=' + id })
}

// 新增站点
export const createSite = (data: SiteVO) => {
  return request.post({ url: '/scenic/site/create', data })
}

// 修改站点
export const updateSite = (data: SiteVO) => {
  return request.put({ url: '/scenic/site/update', data })
}

// 删除站点
export const deleteSite = (id: number) => {
  return request.delete({ url: '/scenic/site/delete?id=' + id })
}

// 批量删除站点
export const deleteSiteList = (ids: number[]) => {
  return request.delete({ url: '/scenic/site/delete-list', params: { ids: ids.join(',') } })
}

// 导出站点
export const exportSite = (params) => {
  return request.download({ url: '/scenic/site/export-excel', params })
}
